function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { remove } from "./util";
var defaultOptions = {
  selector: "img"
};

var LazyContainer = /*#__PURE__*/function () {
  function LazyContainer(_ref) {
    var el = _ref.el,
        binding = _ref.binding,
        vnode = _ref.vnode,
        lazy = _ref.lazy;

    _classCallCheck(this, LazyContainer);

    this.el = null;
    this.vnode = vnode;
    this.binding = binding;
    this.options = {};
    this.lazy = lazy;
    this.queue = [];
    this.update({
      el: el,
      binding: binding
    });
  }

  _createClass(LazyContainer, [{
    key: "update",
    value: function update(_ref2) {
      var _this = this;

      var el = _ref2.el,
          binding = _ref2.binding;
      this.el = el;
      this.options = Object.assign({}, defaultOptions, binding.value);
      var imgs = this.getImgs();
      imgs.forEach(function (el2) {
        _this.lazy.add(el2, Object.assign({}, _this.binding, {
          value: {
            src: "dataset" in el2 ? el2.dataset.src : el2.getAttribute("data-src"),
            error: ("dataset" in el2 ? el2.dataset.error : el2.getAttribute("data-error")) || _this.options.error,
            loading: ("dataset" in el2 ? el2.dataset.loading : el2.getAttribute("data-loading")) || _this.options.loading
          }
        }), _this.vnode);
      });
    }
  }, {
    key: "getImgs",
    value: function getImgs() {
      return Array.from(this.el.querySelectorAll(this.options.selector));
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        return _this2.lazy.remove(el);
      });
      this.vnode = null;
      this.binding = null;
      this.lazy = null;
    }
  }]);

  return LazyContainer;
}();

var LazyContainerManager = /*#__PURE__*/function () {
  function LazyContainerManager(_ref3) {
    var lazy = _ref3.lazy;

    _classCallCheck(this, LazyContainerManager);

    this.lazy = lazy;
    this.queue = [];
  }

  _createClass(LazyContainerManager, [{
    key: "bind",
    value: function bind(el, binding, vnode) {
      var container = new LazyContainer({
        el: el,
        binding: binding,
        vnode: vnode,
        lazy: this.lazy
      });
      this.queue.push(container);
    }
  }, {
    key: "update",
    value: function update(el, binding, vnode) {
      var container = this.queue.find(function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.update({
        el: el,
        binding: binding,
        vnode: vnode
      });
    }
  }, {
    key: "unbind",
    value: function unbind(el) {
      var container = this.queue.find(function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.clear();
      remove(this.queue, container);
    }
  }]);

  return LazyContainerManager;
}();

export { LazyContainerManager as default };